<template>
  <div class="options">

    <div
      v-if="hasOnlyOneContact"
      class="options__singleContact"
    >
      <span>{{ contactList[0].maskedValue }}</span>
    </div>

    <div
      v-else
      class="options__contactList"
    >

      <form class="options__form">
        <div
          v-for="contact in contactList"
          :key="contact.id"
          class="options__contactList__item"
        >
          <VInputRadio
            :id="'selectContact-'+contact.id"
            :name="'selectContact'"
            :label="contact.maskedValue"
            :value="contact.id"
            :isPrincipal="contact.principal"
            v-model="localSelectedContactId"
            @change="updateSelectedValue(contact.id)"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import VInputRadio from '@/components/commons/VInputRadio.vue';

export default {
  name: 'SelectContactOptions',
  components: {
    VInputRadio,
  },
  data() {
    return {
      localSelectedContactId: null,
    };
  },

  props: [
    'contactList',
    'selectedContactId',
  ],

  computed: {
    hasOnlyOneContact() {
      return this.contactList.length === 1;
    },
  },

  watch: {
    contactList(newValue) {
      this.resetSelectedValue();
    }
  },

  methods: {
    updateSelectedValue(contactId) {
      this.$emit('update:selectedContactId', contactId);
    },

    resetSelectedValue() {
      const contactId = this.hasOnlyOneContact
        ? this.contactList[0].id
        : this.contactList.filter(c => c.principal)[0]?.id;

      this.updateSelectedValue(contactId);
    }
  },

  mounted() {
    this.resetSelectedValue();
  },
};
</script>

<style lang="scss">
.options {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__singleContact {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: auto;

    & span {
      background-color: var(--color-grey-2);
      border-radius: 24px;
      padding: 8px 16px;
    }
  }

  &__contactList {
    margin-top: 8px;
    overflow: auto;
    scroll-behavior: auto;
    height:50vh ;

    &__item {
      margin-bottom: 8px;
    }
  }

  .v-input-radio__label {
    border-color: var(--color-grey-1);
    line-height: 1.4;
    padding: 16px 0 16px 16px;

    &:before {
      border-color: var(--color-grey-7);
      border-width: 2px;
      height: 20px;
      margin: 1px 10px 0 0;
      width: 20px;
    }

    &:after {
      height: 12px;
      left: 20px;
      top: 21px;
      width: 12px;
    }
  }

  .v-input-radio__input:not(:checked) + label:after,
  .v-input-radio__input:checked + label:after{
    height: 12px;
    left: 20px;
    top: 21px;
    width: 12px;
  }
}
</style>
